import { notification } from 'antd'
import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

const ERROR_DECODING: Record<string, string> = {
    'bad-moneyflow-id': 'Moneyflow doesn’t exist or you don’t have rights to see it',
    'bad-report-id': 'Report doesn’t exist or you don’t have rights to see it',
    'bad-case-id': 'Case doesn’t exist or you don’t have rights to see it',
}

export const useErrorNotifier = () => {
    const [searchParams,] = useSearchParams()
    const [api, contextHolder] = notification.useNotification()

    useEffect(() => {
        const errorId = searchParams.get('errorId')

        if (errorId) {
            api.error({
                message: ERROR_DECODING[errorId] || 'Unknown error',
                placement: 'bottom'
            })
        }
    }, [api, searchParams])

    return { contextHolder }
}
